import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=b70ab90c&scoped=true"
import script from "./Leader.vue?vue&type=script&lang=js"
export * from "./Leader.vue?vue&type=script&lang=js"
import style0 from "../../../../company/statistics/css/fullCompanyDetail.css?vue&type=style&index=0&id=b70ab90c&prod&scoped=true&lang=css&external"
import style1 from "../../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=b70ab90c&prod&scoped=true&lang=css&external"
import style2 from "./Leader.vue?vue&type=style&index=2&id=b70ab90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ab90c",
  null
  
)

export default component.exports